import { render, staticRenderFns } from "./filter-search.component.vue?vue&type=template&id=556d6b82&scoped=true"
import script from "./filter-search.component.vue?vue&type=script&lang=js"
export * from "./filter-search.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d6b82",
  null
  
)

export default component.exports